//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CalendarMonthReportInputItem } from './CalendarMonthReportInputItem';
import { ReportType } from './Enums';

export class CalendarWeekReportInputItem extends CalendarMonthReportInputItem {
    override readonly Type: ReportType = ReportType.WeekCalendar;

    constructor(initializer?: Partial<Omit<CalendarWeekReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CalendarWeekReportInputItem";
}
